import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type NotificationFragment = { __typename?: 'NotificationDocument', id: string, kind: Types.NotificationKind, module: string, entityType: string, entityId: string, createdAt: Types.TDateISO, readAt?: Types.TDateISO | null, fields: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> };

export type GetMyNotificationsQueryVariables = Types.Exact<{
  unreadOnly: Types.Scalars['Boolean']['input'];
  where?: Types.InputMaybe<Types.NotificationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.NotificationDocumentSortInput> | Types.NotificationDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetMyNotificationsQuery = { __typename?: 'Query', myNotifications?: { __typename?: 'MyNotificationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'NotificationDocument', id: string, kind: Types.NotificationKind, module: string, entityType: string, entityId: string, createdAt: Types.TDateISO, readAt?: Types.TDateISO | null, fields: Array<{ __typename?: 'KeyValuePairOfStringAndString', key: string, value: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMyUnreadNotificationCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyUnreadNotificationCountQuery = { __typename?: 'Query', myUnreadNotificationCount: number };

export const NotificationFragmentDoc = new TypedDocumentString(`
    fragment Notification on NotificationDocument {
  id
  kind
  module
  entityType
  entityId
  fields {
    key
    value
  }
  createdAt
  readAt
}
    `, {"fragmentName":"Notification"});
export const GetMyNotificationsDocument = new TypedDocumentString(`
    query GetMyNotifications($unreadOnly: Boolean!, $where: NotificationDocumentFilterInput, $order: [NotificationDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  myNotifications(
    unreadOnly: $unreadOnly
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...Notification
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment Notification on NotificationDocument {
  id
  kind
  module
  entityType
  entityId
  fields {
    key
    value
  }
  createdAt
  readAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetMyUnreadNotificationCountDocument = new TypedDocumentString(`
    query GetMyUnreadNotificationCount {
  myUnreadNotificationCount
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMyNotifications: build.query<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>({
      query: (variables) => ({ document: GetMyNotificationsDocument, variables })
    }),
    GetMyUnreadNotificationCount: build.query<GetMyUnreadNotificationCountQuery, GetMyUnreadNotificationCountQueryVariables | void>({
      query: (variables) => ({ document: GetMyUnreadNotificationCountDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMyNotificationsQuery, useLazyGetMyNotificationsQuery, useGetMyUnreadNotificationCountQuery, useLazyGetMyUnreadNotificationCountQuery } = injectedRtkApi;
